import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { env, firebaseConfig } from "../config/env";

// Initialize Firebase
let firebases: firebase.app.App;

export { firebaseConfig };

firebases = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const realtimedb = firebase.database();
const newDB = getFirestore(firebases!);
const functions = getFunctions(firebases!, "us-central1");
const storage = firebase.storage();

if (env.USE_FIREBASE_EMU) {
  const host = env.FIREBASE_EMU_HOST;
  db.useEmulator(host, 8080);
  connectFirestoreEmulator(newDB, host, 8080);
  realtimedb.useEmulator(host, 9000);
}

const { Timestamp } = firebase.firestore;


const createFirebaseRef = (collection: any, id: any) =>
  firebase.database().ref(`/${collection}/${id}`);

export {
  firebases,
  db,
  storage,
  Timestamp,
  createFirebaseRef,
  newDB,
  functions,
  realtimedb,
};
export * from "./connection";
export * from "./serviceCompany";
export * from "./serviceCustomer";
export * from "./serviceFiles";
export * from "./serviceUser";
export default db;
